import { onMounted, ref } from 'vue';

import { eqsApi } from '@/api/eqs';
import type { PortfolioResponse } from '@/types/domain';
import { errorMessage } from '@/utils/format';
import { assertPortfolioResponse } from '@/utils/portfolio';

export function usePortfolio() {
  const data = ref<PortfolioResponse | null>(null);
  const loading = ref(true);
  const error = ref('');

  async function load() {
    loading.value = true;
    error.value = '';
    try {
      const payload = await eqsApi.portfolio();
      assertPortfolioResponse(payload);
      data.value = payload;
    } catch (caught) {
      data.value = null;
      error.value = errorMessage(caught);
    } finally {
      loading.value = false;
    }
  }

  onMounted(load);
  return { data, loading, error, load };
}
